import { Cell, Modal } from '@telegram-apps/telegram-ui'
import { Check, ChevronDown } from 'lucide-react'
import { useState } from 'react'
import { useTranslate } from 'shared/lib/i18n'
import type { FeedSort } from '../lib/state'

/** The trigger opens a TGUI bottom-sheet Modal. */
export function SortRow({
	total,
	sort,
	onChange,
}: {
	total: number | undefined
	sort: FeedSort
	onChange: (sort: FeedSort) => void
}) {
	const { prefixT } = useTranslate('pages.feed')
	const [open, setOpen] = useState(false)
	const sortLabels: Record<FeedSort, string> = {
		newest: prefixT('sortNewest'),
		price_asc: prefixT('sortPriceAsc'),
		price_desc: prefixT('sortPriceDesc'),
	}
	return (
		<div className="mt-4 flex h-5 items-center justify-between">
			<span className="text-[13px] text-[var(--tgui--hint_color,rgb(170,170,170))]">
				{total !== undefined ? prefixT('lotCount', { count: String(total) }) : ''}
			</span>
			<button
				type="button"
				onClick={() => setOpen(true)}
				className="flex items-center gap-1 text-[13px] font-medium text-[var(--tgui--link_color,rgb(41,144,255))]"
			>
				{sortLabels[sort]}
				<ChevronDown className="size-3.5" />
			</button>
			<Modal
				open={open}
				onOpenChange={setOpen}
				header={<Modal.Header>{prefixT('sort')}</Modal.Header>}
			>
				<div className="pb-8">
					{(Object.keys(sortLabels) as FeedSort[]).map((key) => (
						<Cell
							key={key}
							onClick={() => {
								onChange(key)
								setOpen(false)
							}}
							after={
								key === sort ? (
									<Check className="size-5 text-[var(--tgui--link_color,rgb(41,144,255))]" />
								) : undefined
							}
						>
							{sortLabels[key]}
						</Cell>
					))}
				</div>
			</Modal>
		</div>
	)
}
